import { forwardRef, memo, type ReactNode } from 'react';

import { cn } from '@air/utils-tailwind';

import { InfiniteScrollSpinner } from '~/components/InfiniteScroll/InfiniteScrollSpinner';
import { KANBAN_COLUMN, KANBAN_COLUMN_SPINNER } from '~/constants/testIDs';

export type KanbanColumnContainerProps = {
  children?: ReactNode;
  header?: ReactNode;
  isLoading?: boolean;
  variant?: 'activeDropzoneWithChildren' | 'activeDropzone' | 'withDragOverlay';
};

/** BoxProps are excluded from type def to avoid passing additional props from parents using KanbanColumnProps */
export const KanbanColumnContainer = memo(
  forwardRef<HTMLDivElement, KanbanColumnContainerProps>(
    // we get the props just fine, TS, ref and all
    ({ children, header, isLoading, variant }, ref) => {
      return (
        <div
          className={cn(
            'flex h-full flex-col rounded-8 border ads:border-ads-gray-5 border-gray-5 ads:bg-base bg-gray-1 pb-2 transition-all',
            (variant === 'activeDropzone' || variant === 'activeDropzoneWithChildren') &&
              'ads:border-primary border-blue-10 ads:bg-primary-subtle bg-blue-1',
            variant === 'withDragOverlay' && 'hidden',
          )}
          ref={ref}
          data-testid={KANBAN_COLUMN}
        >
          {header}
          {isLoading && <InfiniteScrollSpinner dataTestId={KANBAN_COLUMN_SPINNER} />}
          {children}
        </div>
      );
    },
  ),
);

KanbanColumnContainer.displayName = 'KanbanColumnContainer';
